import {
  type TFaqRequest,
  type TFaqResponse
} from '@/components/Shared/widgets/faq-main-page/types/faq.types';
import { ApiConnector } from '@/integrations/api.connector';

class AdminFaqApi extends ApiConnector {
  private baseUrl = 'admin/faq';

  public async getAllFaq() {
    return this.call<unknown, TFaqResponse[]>({
      path: this.baseUrl,
      cancelable: true
    });
  }

  public async getFaqArticle(uuid: string) {
    return this.call<unknown, TFaqResponse>({
      path: `${this.baseUrl}/${uuid}`,
      cancelable: true
    });
  }

  public async createFaq(body: TFaqRequest) {
    return this.call<TFaqRequest, TFaqResponse>({
      path: this.baseUrl,
      method: 'post',
      body
    });
  }

  public async updateFaq(uuid: string, body: TFaqRequest) {
    return this.call<TFaqRequest, TFaqResponse>({
      path: `${this.baseUrl}/${uuid}`,
      method: 'patch',
      body
    });
  }
}

export const adminFaqApi = new AdminFaqApi();
